// extracted by mini-css-extract-plugin
export default {"statusPill":"view-details_statusPill__GWlkV","statusDot":"view-details_statusDot__Ogqei","nameContainer":"view-details_nameContainer__POY0L"};